import ChromeWebStoreLogo from "../assets/chrome-web-store.svg";
import { CedeLogo } from "../assets/cede-store-logo";
import { HtmlComponent } from "../types/component";

const style: HtmlComponent["style"] = (theme) => `
  .modal-container {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    height: 100%;
    width: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    animation: fade-in 0.3s ease-in-out;
  }

  .modal {
    max-width: 100%;
    width: 600px;
    height: 500px;
    border-radius: 14px;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    background: ${theme.palette.background.default};
    overflow-y: auto;
    overflow-x: hidden;
    box-shadow: 0px 4px 70px 50px #5EA6FF26;
  }

  .modal-header {
    display: flex;
    flex-direction: row-reverse;
    width: auto;
    min-height: 50px;
    padding: 8px;
  }

  .close-icon {
    width: 24px;
    height: 24px;
    fill: rgb(155, 155, 155);
  }

  .modal-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: calc(100% - 50px);
    overflow: hidden;
    padding: 10px 50px 25px 50px;
    justify-content: space-between;
  }

  .modal-title {
    width: 100%;
  }

  .modal-title img {
    width: 110px;
    height: 110px;
  }

  .modal-title h1 {
    font-weight: 600;
    margin-top: 28px;
    font-size: 24px;
    color: ${theme.palette.text.primary};
  }

  .modal-title h1 span {
    color: ${theme.palette.primary.main};
  }

  .modal-title p {
    font-size: 14px;
    color: ${theme.palette.text.secondary};
    line-height: 18px;
    font-weight: 400;
    margin-top: 20px;
  }

  .modal-title p.modal-content-last {
    margin-top: 35px;
  }

  .modal-title p strong {
    color: ${theme.palette.text.secondary};
  }

  .modal-content-image:hover {
    box-shadow: 0px 0px 20px 14px rgba(94, 166, 255, 0.31);
  }
  
  .modal-content-image {
    margin-top: 20px;
    transition: box-shadow 0.3s ease-in-out;
    box-shadow: 0px 0px 0px 0px rgba(94, 166, 255, 0.31);
    height: 67px;
    width: 220px;
    border: 1px solid ${theme.palette.cedeComponentHr};
    border-radius: 13px;
    padding: 0 10px;
    cursor: pointer;
  }

  .modal-banner-link {
    color: ${theme.palette.text.secondary};
    margin-top: 20px;
  }
`;

const html: HtmlComponent["html"] = () => `
  <div class="modal-container" id="cede-modal-onboarding">
    <div class="modal">
      <header class="modal-header">
        <button class="icon-button" id="close-modal">
          <svg class="close-icon" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="CloseIcon"><path d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path></svg>
        </button>
      </header>
      <section class="modal-content">
        <div class="modal-title">
          <div class="cede-logo">
            ${CedeLogo}
          </div>
          <h1>
            <span>Cede.store</span>
            is not detected
          </h1>
          <p>
            To proceed, you will need to <strong>download</strong> the extension from the 
            <strong>Chrome Web Store</strong>. Let you guide by the <strong>onboarding flow</strong>.
          </p>
          <p class="modal-content-last">
            Click below to access the Chrome Web Store
          </p>
        </div>
        <img id="chrome-web-store" src=${ChromeWebStoreLogo} class="modal-content-image" alt="Download from Chrome Web Store" />
        <a href="https://cede.store" target="_blank" class="modal-banner-link">
          Discover more about cede.store
        </a>
      </section>
    </div>
  </div>
`;

export type DisplayInstallationModalConfig = {
  readOnlyOnboarding?: boolean;
  callbackUrl: string;
};

const action: (params?: DisplayInstallationModalConfig) => HtmlComponent["action"] = (params) => (component, ui) => {
  const closeBtn = component.html.querySelector("#close-modal");
  const chromeWebStoreBtn = component.html.querySelector("#chrome-web-store");

  if (!closeBtn || !chromeWebStoreBtn) return;

  closeBtn.addEventListener("click", () => {
    ui.remove(component);
  });

  chromeWebStoreBtn.addEventListener("click", () => {
    // stores a value in the local storage for the extension to know from where the user installed the extension.
    localStorage.setItem("cede.store-onboarding", JSON.stringify(params ?? {}));
    window.open("https://chrome.google.com/webstore/detail/cedestore/dcfphbfmjohnlcpelbhfbjolhmmlcbhd", "_blank");
  });
};

export const OnBoardingModal = (params?: DisplayInstallationModalConfig) => ({
  style,
  html,
  action: action(params),
});
